import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../styles/floatingForm.css'
import deleteIcon from '../assets/images/icons/delete_icon.svg'

const CreateItineraryInPage = () => {
   const navigate = useNavigate();
  const [locations, setLocations] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [date, setDate] = useState('');
  const [description, setDescription] = useState('');

  const [isExist, setIsExist] = useState(false);

  const [itineraryDays, setItineraryDays] = useState([{ date: '', description: '' }]);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchLocations = async () => {
      const response = await api.get('/location/get-all');
      setLocations(response.data.data);
    };

    const fetchPackages = async () => {
      const response = await api.get('/product/get-all');
      setPackages(response.data.data);
    };

    fetchLocations();
    fetchPackages();
  }, []);


    const checkIfExist = async () => {
        try{
            const response = await api.get(`/itinerary/checkpakage/${selectedPackage}/${selectedLocation}`);
            setIsExist(response.data.data);
        }catch(e){
            if(e.response.data.status === "error"){
                setIsExist(false)
            }
        }
    };


    useEffect(() => {
        if(selectedLocation && selectedPackage ){
            checkIfExist()
        }
    },[selectedPackage,selectedLocation])

 const validateForm = () => {
  const errors = {};

  if (!selectedPackage) errors.selectedPackage = 'Please select a package';
  if (!selectedLocation) errors.selectedLocation = 'Please select a location';

  itineraryDays.forEach((entry, index) => {
    if (!entry.date) {
      errors[`date-${index}`] = 'Day is required';
    }
    if (!entry.description.trim()) {
      errors[`description-${index}`] = 'Description is required';
    }
  });

  return errors;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setErrors({});

    if(isExist){
        toast.error("Itinerary for this package and location already exists");
        return;
    }

    const formData = new FormData();
    formData.append('location_id', selectedLocation);
    formData.append('card_id', selectedPackage);

    itineraryDays.map(el => {
        formData.append('date[]', (el.date))
    })

    itineraryDays.map(el => {
        formData.append('description[]', (el.description))
    })

    try {
      const response = await api.post('/itinerary/add', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.status === "success") {
              toast.success(`Itinerary created successfully!`);
              handleCancel();
      } else {
        toast.error(response.data || 'Failed to create Itinerary');
      }
    } catch (error) {
      toast.error(error.response?.data || 'Error creating Itinerary. Please try again later.');
      toast.error('Error creating itinerary');
    }
  };

  const handleCancel = () => {
    setSelectedPackage('');
    setSelectedLocation('');
    setDate('');
    setDescription('');
    setItineraryDays([{ date: '', description: '' }]);
    navigate('/manage-itinerary');
  };

  const handleAddDay = () => {
    setItineraryDays([...itineraryDays, { date: '', description: '' }]);
    };

const handleRemoveDay = (index) => {
  const updated = [...itineraryDays];
  updated.splice(index, 1);
  setItineraryDays(updated);
};




  return (
    <div className='floating-form-container'  >
      <div className="heading">
        <h2>Itinerary Details</h2>
      </div>

        <form onSubmit={handleSubmit}>
            <div className="form-container">

                <div className="section-1">
                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="name">Select Package *</label>
                        <select className={`form-control ${errors.selectedPackage ? 'is-invalid' : ''}`} value={selectedPackage} onChange={(e) => setSelectedPackage(e.target.value)} >
                  <option value=''>Select Package</option>
                  {packages.map((pkg) => (
                    <option key={pkg.id} value={pkg.id}>
                      {pkg?.packagename}
                    </option>
                  ))}
                </select>
                <b>{errors.selectedPackage && <span className='text-danger small'>{errors.selectedPackage}</span>}</b>
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="email">Select Location *</label>
                        <select className={`form-control ${errors.selectedLocation ? 'is-invalid' : ''}`} value={selectedLocation} onChange={(e) => setSelectedLocation(e.target.value)} >
                  <option value=''>Select Location</option>
                  {locations.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.location}
                    </option>
                  ))}
                </select>
                <b>{errors.selectedLocation && <span className='text-danger small'>{errors.selectedLocation}</span>}</b>
                    </div>

                    {itineraryDays.map((entry, index) => (
                        <div key={index} className="day-block wid-100">
                            <div className="input-container-floating-form wid-30">
                            <label>Day *</label>
                            <input
                                type="text"
                                className={`form-control ${errors[`date-${index}`] ? 'is-invalid' : ''}`}
                                value={entry.date}
                                onChange={(e) => {
                                const updated = [...itineraryDays];
                                updated[index].date = e.target.value;
                                setItineraryDays(updated);
                                }}
                            />
                            <b>{errors[`date-${index}`] && <span className='text-danger small'>{errors[`date-${index}`]}</span>}</b>
                            </div>

                            <div className="input-container-floating-form wid-100">
                                {index > 0 && (
                                <button type="button" className="remove-btn remove-day" onClick={() => handleRemoveDay(index)}>
                                    <img src={deleteIcon} alt="delete" />
                                </button>
                                )}
                            </div>

                            <div className="input-container-floating-form wid-100">
                            <label>Description *</label>
                            <ReactQuill
                                value={entry.description}
                                onChange={(value) => {
                                const updated = [...itineraryDays];
                                updated[index].description = value;
                                setItineraryDays(updated);
                                }}
                                className={`react-quill ${errors[`description-${index}`] ? 'is-invalid' : ''}`}
                                placeholder='Enter Description'
                            />
                            <b>{errors[`description-${index}`] && <span className='text-danger small'>{errors[`description-${index}`]}</span>}</b>
                            </div>

                            
                        </div>
                        ))}

                        <button type="button" onClick={handleAddDay} className='add-day'>+ Add Day</button>

                    
                </div>

                {/* <hr className='form-rule' /> */}

            </div>

            <div className="form-btn-container">

                <button type='submit'>Create</button>
                <button type='reset' onClick={handleCancel}>Cancel</button>
            </div>


        </form>

    </div>
  );
};

export default CreateItineraryInPage;
